export default {
    state: {
        errors: []
    },
    mutations: {
        setErrors (state, payload) {
            state.errors = payload
        },
        addError (state, payload) {
            state.errors.push(payload)
        }
    },
    actions: {
        pushError(context, error) {
            context.commit('addError', error)
        }
    }
}
